import { sendGet, sendPut } from 'helpers/axiosNotifications';

export const getNotifications = (params) => sendGet('/api/notifications', params);
export const getTotalNotifications = (params) => sendGet('api/total/notifications', params);

export const updateAllNotificationReadAll = (params) => sendPut('/api/see-all', params);
export const updateNotificationRead = (params) => sendPut('/api/update-read', params);
export const updateNotificationView = (params) => sendPut('/api/update-view', params);
export const updateNotificationViewRow = (params) => sendPut('/api/update/notification', params);
